const en = {
  translation: {
    dashboard: 'Dashboard',
    de: 'of',

    no_tipo_recurso: 'No resources of this type downloaded',
    no_tipo_agrupacion: 'No groups of this type downloaded',

    OBJECT_TYPE_Recurso: 'Resource',
    OBJECT_TYPE_Agrupacion: 'Group',

    cantidad_recursos: 'Resources in this collection',

    //info del rankin
    posicion: 'Position',
    titulo: 'Title',

    //footer
    contacto: 'Contact',
    linea_nacional: 'National line: 01-8000-51-0258, Line in Bogotá: 4890400',
    horario_atencion:
      'Office Hours: Monday to Friday - 8:00 a.m. to 5:00 p.m.',
    derechos_reservados: 'All rights reserved',

    Textual: 'Texts',
    Software: 'Software',
    Interactivo: 'Interactive',
    Grafico: 'Images',
    Sonoro: 'Audios',
    Audiovisual: 'Videos',
    Multimedia: 'Multimedia',

    calificacion: 'Rating',
    catalogo: 'Catalog',

    //Descripcion recurso
    comentario: 'Comments',
    no_comentarios: 'This resource has no comments',
    califica_recurso: 'Rate this resource',
    agregar_favoritos: 'Add to favorites',
    palabra_clave: 'Keywords',
    publico_objetivo: 'Target audience',
    tipo_contenido: 'Content Type',
    autores: 'Authors',
    licenciante: 'Licensor',
    sugerencia_uso_pedagogico: 'Pedagogical use suggestion',
    descripcion: 'Description',
    recursos_relacionados: 'Related resources',
    opciones: 'See options',
    ingresar_colombia_aprende: 'To add the resource to Favorites you need to log in with your portal account',
    colombia_aprende: 'Colombia Aprende',
    iniciar_sesion_registro: 'Login or Register',

    //Landing
    contenidos_destacados: 'Featured contents',
    landing_mensaje:
      'The Ministry of National Education of Colombia makes available to the educational institutions, students, educators and the general public, through the Catalog of Digital Educational Resources (RED Aprende) a large number of digital educational resources.',
    nuevos_recursos: 'New Resources',
    recursos_colecciones_mas_vistas: 'Most viewed resources and collections',

    //header
    header_agrupaciones: 'Groupings',
    header_recursos: 'Resources',

    //aside
    aside_descargas: 'Downloads',
    aside_ajustes: 'Settings',

    explorar: 'Explore',

    agregacion: 'Collection',
    destilacion: 'Ranking',
    cronologia: 'Timeline',

    todas: 'All',
    tipo_agrupacion: 'Grouping type',
    buscar_agrupacione_descargas: 'Search groups',

    landing_no_resultados: 'Sorry, no search results found!',
    landing_tipo_contenido: 'Content type',
    selecciona: 'Select',

    poblacion_objetivo: 'Target population',
    nivel_educativo: 'Educational level',
    nucleo_basico: 'Basic Knowledge Core',
    compartir_facebook: 'Share on Facebook',
    compartir_twitter: 'Share on Twitter',
    compartir_whatsapp: 'Share on WhatsApp',
    tipo_licencia: 'License type',

    toast_guardado: 'Successfully saved!',
    toast_descargado_prev: 'Previously downloaded resource',
    toast_eliminado: 'Resource successfully removed',
    toast_completar_accion: 'Action could not be completed',
    toast_descarg_iniciada: 'Download in progress',
    toast_descarga_finalizada: 'Download finished',
    toast_descarga_error: 'An error has occurred, please try again',

    panel_minimizar: 'Minimize panel',
    panel_maximizar: 'Maximize panel',

    dl_desc_recurso: 'Resource',

    dl_element_borrar: 'Delete resource',
    dl_element_ver: 'View details',

    empty_para_descargar: 'To download resources go to',
    empty_no_descargas: 'You have not downloaded resources',

    empty_para_descarga_agrupaciones: 'To download groups go to',
    empty_no_descargas_agrupaciones: 'You have not downloaded groups',

    header_cambiar_idioma: 'Change language',
    header_mis_agrupaciones: 'My groups',

    landing_resultados_encontrados: 'Results found by',
    landing_reiniciar_busqueda: 'Reset search',
    landing_filtrar: 'Filter',
    landing_limpiar_filtros: 'Reset',
    landing_tipos_recurso: 'Resource types',
    landing_formatos: 'Formats',
    landing_dificultad: 'Difficulty',
    landing_nivel_educativo: 'Educational level',
    landing_area_conocimiento: 'Knowledge areas',
    landing_filtros: 'Filters',

    imagenes: 'Images',
    videos: 'Videos',
    documentos: 'Documents',
    audio: 'Audios',
    otros: 'Others',
    todos: 'All',

    inicio: 'Home',
    descargas: 'My Downloads',
    buscar: 'Search',
    espanol: 'ES',
    ingles: 'EN',
    guardar_recurso: 'Save resource',
    descargar_recurso: 'Download resource',
    acerca: 'About',
    licencia: 'License',
    documentacion: 'Documentation',
    ver_nueva_pestana: ' Open in new tab',
    compartir: 'Share',

    modal_eliminar_titulo: 'Delete',
    modal_eliminar_mensaje: 'Are you sure you want to delete the resource ',
    modal_eliminar_cancelar: 'Cancel',
    modal_eliminar_borrar: 'DELETE',

    buscar_descargas: 'Search downloads',

    borrar: 'Delete',
    info: 'Resource information',
    recurso_descargado: 'Resource downloaded',
    descargar: 'Download',
    downloaded: 'Downloaded',

    portugues: 'PT',

    header_colecciones: 'Collections',
    sin_colecciones_para_mostrar: "There aren't collections to display in the section.",
    ir_a_coleccion: 'Go to the collection',
    ver_comentarios: 'See comments',
    recursos_mejor_puntuados: 'Top rated resources',
    visualizacion_no_disponible: 'The resource display is not available',

    // Textos de Header.js
    header_site_title: 'RED Aprende',
    header_govco_title: 'GOV.CO',
    header_login: 'Login',
    header_language: 'Language',
    header_favorites: 'Favorites',
    header_loading: 'loading...',
    header_spanish: 'Spanish',
    header_english: 'English',
    header_portuguese: 'Portuguese',
    header_govco_nav_aria: 'Main Gov.co navigation',
    header_login_aria: 'Log in to the platform',
    header_spanish_aria: 'Select Spanish language',
    header_english_aria: 'Select English language',
    header_portuguese_aria: 'Select Portuguese language',
    header_main_nav_aria: 'Main site navigation',
    header_main_menu_aria: 'Main application menu',
    header_home_link_aria: 'Go to home page',
    buscador_aria: 'Search field by keyword',
    buscar_aria: 'Button to start the search',
    header_collections_aria: 'Go to collections section',
    header_favorites_aria: 'View favorite resources',

    // Textos de Footer.js
    footer_red_aprende: 'RED Aprende',
    footer_collections: 'Collections',
    footer_data_treatment: 'Personal data treatment',
    footer_privacy_terms: 'Privacy and terms of use',
    footer_digital_security: 'Digital security',
    footer_cookies: 'Cookies',
    footer_educational_level: 'Educational Level',
    footer_first_child_hood: 'Early childhood',
    footer_preschool_basic_media: 'Preschool, basic and secondary',
    footer_superior_education: 'Higher education',
    footer_work_human_development_education: 'Education for work and human development',
    footer_areas_subjects: 'Areas and subjects',
    footer_science_math: 'Science and mathematics',
    footer_language_humanities_society: 'Language, humanities and society',
    footer_art_culture_expression: 'Art, Culture and Expression',
    footer_physical_education: 'Physical education, recreation and sports',
    footer_health_wellness: 'Health and well-being',
    footer_healthy_habits: 'Promote healthy habits and integral well-being',
    footer_external_links: 'External links',
    footer_currideas: 'CurrIdeas',
    footer_colombia_aprende_link: 'Colombia Aprende',
    footer_mineducacion_title: 'National Ministry of Education',
    footer_address_label: 'Address:',
    footer_address_value: 'Calle 43 No. 57 - 14. CAN. Bogotá, Colombia. Postal Code 111321.',
    footer_phone_conmutator_label: 'Switchboard Phone:',
    footer_phone_conmutator_value: '(601) 22 22800',
    footer_free_line_label: 'Toll-free line outside Bogotá:',
    footer_free_line_value: '018000 - 510258',
    footer_attention_schedule_label: 'Hours of operation',
    footer_attention_schedule_value: 'Monday to Thursday from 8:00 a.m. to 5:00 p.m. and Friday from 7:00 a.m. to 4:00 p.m. Continuous day.',
    footer_tech_support_label: 'Technical support - Information systems. Phone:',
    footer_tech_support_value: '(601) 432 1215',
    footer_national_free_line: 'National toll-free line',
    footer_anti_corruption_email_label: 'Anti-corruption email:',
    footer_judicial_notifications_email_label: 'Judicial notifications email:',
    footer_channels_attention: 'Physical and electronic channels for public attention',
    footer_social_networks: 'Social networks',
    footer_interest_links: 'Links of interest',
    footer_terms_conditions_aria: 'View terms and conditions',
    footer_policies_aria: 'View policies',
    footer_sitemap_link_aria: 'View site map',
    footer_accessibility_aria: 'Go to accessibility section',
    footer_administration_aria: 'Go to administration page',
    footer_colombia_aprende_link_bottom_aria: 'Open Colombia Aprende platform link',

    // Textos de Accessibility.js
    accessibility_contrast: 'Contrast',
    accessibility_reduce_letter: 'Reduce letter',
    accessibility_increase_letter: 'Increase letter',

    // Textos de Landing.js
    landing_banner_title: 'Explore and teach with RED Aprende',
    landing_banner_subtitle: 'More than <span>25 thousand digital resources</span> ready for <b>teachers and students</b>',
    landing_banner_explore_collections: 'Explore collections now',
    landing_more_collections: 'Explore all collections',
    landing_education_title: 'Find what you need according to your educational stage',
    landing_education_primary: 'Early childhood',
    landing_education_basic: 'Preschool, basic and secondary',
    landing_education_superior: 'Higher education',
    landing_education_work: 'Education for work and human development',
    landing_areas_title: 'Explore by areas of knowledge',
    landing_science_math_title: 'Science and Mathematics',
    landing_science_math_description: 'Explore from basic sciences to technical applications.',
    landing_view_resources: 'View resources ',
    landing_language_humanities_title: 'Language, Humanities and Society',
    landing_language_humanities_description: 'Communication, history, philosophy and citizenship in one place',
    landing_habits_title: 'Promote healthy habits and integral well-being.',
    landing_habits_description: 'Materials for teacher training and pedagogical strengthening.',
    landing_art_culture_title: 'Art, Culture and Expression',
    landing_art_culture_description: 'Resources for artistic expression, ethics and cultural life.',
    landing_health_wellness_title: 'Health and Well-being',
    landing_health_wellness_description: 'Promote healthy habits and integral well-being.',
    landing_learn_how_to_learn: 'Choose how you want to learn',
    landing_joinus_title: 'Teachers from all over the country already use RED Aprende.',
    landing_joinus_subtitle: 'Join and take advantage of the digital resources available for your classroom.',
    landing_banner_title_aria: 'Main section: Explore and teach with RED Aprende',
    landing_banner_explore_collections_aria: 'Explore collections from the main section',
    landing_more_collections_aria: 'Explore all collections',
    landing_education_primary_aria: 'Educational phase: Early childhood',
    landing_education_basic_aria: 'Educational phase: Preschool, basic and secondary',
    landing_education_superior_aria: 'Educational phase: Higher education',
    landing_education_work_aria: 'Educational phase: Education for work and human development',
    landing_view_resources_science_aria: 'View Science and Mathematics resources',
    landing_view_resources_language_aria: 'View Language, Humanities and Society resources',
    landing_view_resources_habits_aria: 'View Healthy Habits and Integral Well-being resources',
    landing_view_resources_art_aria: 'View Art, Culture and Expression resources',
    landing_view_resources_health_aria: 'View Health and Well-being resources',
    landing_resource_format_textual_aria: 'Explore textual format resources',
    landing_resource_format_graphic_aria: 'Explore graphic format resources',
    landing_resource_format_sonorous_aria: 'Explore sonorous format resources',
    landing_resource_format_audiovisual_aria: 'Explore audiovisual format resources',
    landing_resource_format_multimedia_aria: 'Explore multimedia format resources',
    landing_resource_format_interactive_aria: 'Explore interactive format resources',
    landing_resource_format_textual_alt: 'Icon of textual resources',
    landing_resource_format_graphic_alt: 'Icon of graphic resources',
    landing_resource_format_sonorous_alt: 'Icon of sonorous resources',
    landing_resource_format_audiovisual_alt: 'Icon of audiovisual resources',
    landing_resource_format_multimedia_alt: 'Icon of multimedia resources',
    landing_resource_format_interactive_alt: 'Icon of interactive resources',

    // Textos de Objeto.js
    objeto_view_group_aria: 'View details of group {{title}}',
    objeto_view_resource_aria: 'View details of resource {{title}}',
    objeto_image_alt: 'Preview image for {{title}}',
    objeto_resources_count_aria: 'Number of resources: {{count}}',
    objeto_resource_singular: 'resource',
    objeto_resource_plural: 'resources',
    objeto_average_rating_aria: 'Average rating: {{rating}} out of 5 stars',
    objeto_view_collection_aria: 'View collection',
    objeto_view_collection: 'View collection'
  }
};

export default en;
